import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcPlayFill(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.42 9.87c1.588.976 1.588 3.285 0 4.26L8.196 20.408c-1.666 1.023-3.808-.176-3.808-2.13V5.724c0-1.955 2.142-3.154 3.808-2.13z"
  }));
}
var IcPlayFill = createNolIcon(/*#__PURE__*/forwardRef(SvgIcPlayFill));

export { IcPlayFill as I };
